var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { isNil } from '../../value/isNil';
import { isNilOrEmpty } from '../../value/isNilOrEmpty';
import { typeOf } from "../../type/typeOf";
/**
 * Finds the indexes of an array that match the predicate
 *
 * @category Array
 * @template {T} - The type of the array
 * @param {T[]} array - The array of items
 * @param {(item: T) => boolean} predicate - The predicate to determine if an item in the array is a match
 * @returns {number[]}
 * @example
 * const array = [7, 25, 21, 17, 42];
 *
 * findIndexes(array, item => item >= 25 )  //=> [1, 4]
 * @docgen_example
 * const array = [7, 25, 21, 17, 42];
 *
 * findIndexes(array, item => item >= 25 );
 */
export var findIndexes = function (array, predicate) {
    if (typeOf(array) !== 'array' || isNilOrEmpty(array) || isNil(predicate))
        return [];
    var output = [];
    for (var i = 0; i < array.length; i++) {
        if (predicate(array[i])) {
            output = __spreadArray(__spreadArray([], output, true), [i], false);
        }
    }
    return output;
};
